import { listBanks, verifyAccountNumber, estatePayoutAccount } from './endpoints'
import { authCall } from '.'
import useSWR from 'swr'
import { Bank, ListBanksResponse, VerifyAccountNumberRequest, VerifyAccountNumberResponse, EstatePayoutAccountRequest, EstatePayoutAccountResponse } from '../interfaces/bank'


// ── Service ───────────────────────────────────────────────────────────────────

const BankingService = {
  useGetBanks: () => {
    return useSWR<Bank[]>(
      listBanks,
      async () => {
        const res = await authCall<{ success: boolean; message: string; data: ListBanksResponse }>({
          url: listBanks,
          method: 'get',
        })
           const payload = (res as any)?.data ?? res
        return Array.isArray(payload) ? payload : (payload?.banks ?? [])
      },
      {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
        revalidateOnReconnect: true,
        dedupingInterval: 2000,
      }
    )
  },

  verifyAccountNumber: async (data: VerifyAccountNumberRequest) => {
    const res = await authCall<{ success: boolean; message: string; data: VerifyAccountNumberResponse } | VerifyAccountNumberResponse>({
      url: verifyAccountNumber,
      method: 'post',
     data: {
        accountNumber: data.accountNumber,
        bankCode: data.bankCode,
      },
    })
    // Handle: { data: { accountName } } or { accountName } directly
    const payload = (res as any)?.data ?? res
    return payload as VerifyAccountNumberResponse
  },

  setEstatePayoutAccount: async (data: EstatePayoutAccountRequest) => {
    const res = await authCall<{ success: boolean; message: string; data: EstatePayoutAccountResponse }>({
      url: estatePayoutAccount,
      method: 'post',
      data,
    })
    return res
  },

  getEstatePayoutAccount: async () => {
    const res = await authCall<any>({
      url: estatePayoutAccount,
      method: 'get',
    })
    return ((res as any)?.data ?? res) as any
  },
}

export default BankingService




